function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/** Coarse status grouping used to drive the date/time rules. */

/** Result of validating a create-encounter form's Start Time / End Time fields. */

var DATE_FIELD_TYPES = ["date", "datetime"];
var COMPLETED_STATUSES = ["finished", "completed"];
var ONGOING_STATUSES = ["arrived", "triaged", "in-progress", "ongoing"];

/** Finds the encounter status field (dropdown whose name mentions "status"). */
function findStatusField(fields) {
  return fields.find(function (field) {
    return field.name.toLowerCase().includes("status");
  });
}

/** Finds a date/datetime field whose name contains the given keyword. */
function findDateField(fields, keyword) {
  return fields.find(function (field) {
    return DATE_FIELD_TYPES.includes(field.type) && field.name.toLowerCase().includes(keyword);
  });
}

/** Classifies a raw status value into a completed / ongoing / other bucket. */
function classifyStatus(value) {
  if (!value) return "other";
  var normalized = value.toLowerCase();
  if (COMPLETED_STATUSES.includes(normalized)) return "completed";
  if (ONGOING_STATUSES.includes(normalized)) return "ongoing";
  return "other";
}

/** Parses a stored date/datetime string into a valid Date, or null when missing or invalid. */
function parse(value) {
  if (!value) return null;
  var date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/**
 * Whether the given field is the End Time field that becomes mandatory once the
 * selected status is completed. Used to show a required marker on the field.
 */
export function isEndTimeRequired(config, formData, field) {
  var _config$fields;
  var fields = (_config$fields = config === null || config === void 0 ? void 0 : config.fields) !== null && _config$fields !== void 0 ? _config$fields : [];
  var endField = findDateField(fields, "end");
  if (!endField || endField.name !== field.name) return false;
  var statusField = findStatusField(fields);
  return classifyStatus(statusField ? formData[statusField.name] : undefined) === "completed";
}

/**
 * Validates the Start Time / End Time fields of the create-encounter form against
 * the selected status. Rules: end must be after start when both are present; a
 * completed encounter cannot start or end in the future; an ongoing encounter's
 * end (when entered) must be in the future; datetime fields must include a time.
 */
export function validateEncounterDateTimes(encounterConfig, formData, t) {
  var _encounterConfig$fiel, _startField$label, _endField$label;
  var fields = (_encounterConfig$fiel = encounterConfig === null || encounterConfig === void 0 ? void 0 : encounterConfig.fields) !== null && _encounterConfig$fiel !== void 0 ? _encounterConfig$fiel : [];
  var statusField = findStatusField(fields);
  var startField = findDateField(fields, "start");
  var endField = findDateField(fields, "end");
  var now = new Date();
  var status = classifyStatus(statusField ? formData[statusField.name] : undefined);
  var start = startField ? parse(formData[startField.name]) : null;
  var end = endField ? parse(formData[endField.name]) : null;
  var startLabel = (_startField$label = startField === null || startField === void 0 ? void 0 : startField.label) !== null && _startField$label !== void 0 ? _startField$label : t("start_time", {
    defaultValue: "Start Time"
  });
  var endLabel = (_endField$label = endField === null || endField === void 0 ? void 0 : endField.label) !== null && _endField$label !== void 0 ? _endField$label : t("end_time", {
    defaultValue: "End Time"
  });
  var fail = function fail(fieldNames, message) {
    return {
      isValid: false,
      invalidFieldNames: Array.from(new Set(fieldNames.filter(Boolean))),
      errorMessages: [message]
    };
  };
  var _iterator = _createForOfIteratorHelper(fields),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var field = _step.value;
      if (field.type === "datetime") {
        var value = formData[field.name];
        if (value && value.length === 10) {
          return fail([field.name], t("encounter_incomplete_datetime", {
            defaultValue: "{{field}} requires both date and time",
            field: field.label
          }));
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (start && end && end.getTime() <= start.getTime()) {
    return fail([startField === null || startField === void 0 ? void 0 : startField.name, endField === null || endField === void 0 ? void 0 : endField.name], t("encounter_end_after_start", {
      defaultValue: "{{endField}} must be after {{startField}}",
      endField: endLabel,
      startField: startLabel
    }));
  }
  if (status === "completed") {
    if (endField && !end) {
      return fail([endField.name], t("encounter_end_required_completed", {
        defaultValue: "{{field}} is required for a completed encounter",
        field: endLabel
      }));
    }
    if (start && start.getTime() > now.getTime()) {
      return fail([startField === null || startField === void 0 ? void 0 : startField.name], t("encounter_start_not_future", {
        defaultValue: "{{field}} cannot be in the future for a completed encounter",
        field: startLabel
      }));
    }
    if (end && end.getTime() > now.getTime()) {
      return fail([endField === null || endField === void 0 ? void 0 : endField.name], t("encounter_end_not_future", {
        defaultValue: "{{field}} cannot be in the future for a completed encounter",
        field: endLabel
      }));
    }
  }
  if (status === "ongoing" && end && end.getTime() <= now.getTime()) {
    return fail([endField === null || endField === void 0 ? void 0 : endField.name], t("encounter_end_must_be_future", {
      defaultValue: "{{field}} must be in the future for an ongoing encounter",
      field: endLabel
    }));
  }
  return {
    isValid: true,
    invalidFieldNames: [],
    errorMessages: []
  };
}